import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import FeedbackList from '../FeedbackList';
import FeedbackDetail from '../FeedbackDetail';
import SearchBar from '../SearchBar';
import StatsBar from '../StatsBar';
import StatsTable from '../StatsTable';
import Modal from '../Modal';

class Detail extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                
                <div className="row feedbacks" >

                    {this.props.state.feedback_detail != null &&
                        <FeedbackDetail center={true} />
                    }

				</div>

                    {this.props.state.feedback_detail != null &&
				        <Modal modal={this.props.state.modal}/>            
                    }
			</div>    
        );
    }
}

function mapStateToProps(state) {
    return { state:state }
}

export default connect(mapStateToProps)(Detail);